import { Component, ViewChild } from '@angular/core';
import { BwUserService } from '@app/shared';
import { FilterWidgetComponent } from '@app/shared/components/filter-widget/filter-widget.component';
import { PaginatorComponent } from '@app/shared/components/paginator/paginator.component';
import { SearchWidgetComponent } from '@app/shared/components/search-widget/search-widget.component';
import { ToastService } from '@teorema/patron';
import { FilterField } from 'src/app/models/filter-field.model';
import { FindOptions } from 'src/app/models/find-options.model';

@Component({
  templateUrl: './bw-users-pending-list.component.html',
  standalone: false,
})
export class BwUsersPendingListComponent {
  bwUsers: any[] = [];
  loading: boolean = false;
  loadingBwUser?: string;
  totalItems = 0;
  findOptions: FindOptions = {
    orderBy: 'bw_users.name',
    storageKey: 'pending-users-find-options2',
    q: '',
    withs: ['customer'],
    filters: [
      new FilterField({
        name: 'status',
        key: 'status',
        label: 'Status',
        type: 'select',
        multiple: true,
        bindLabel: 'label',
        bindValue: 'value',
        options: [
          { label: 'Pendente', value: 'Pendente' },
          { label: 'Aceito', value: 'Aceito' },
          { label: 'Recusado', value: 'Recusado' },
        ],
        value: [{ label: 'Pendente', value: 'Pendente' }],
      }),
    ],
  };

  @ViewChild('paginator') paginator!: PaginatorComponent;
  @ViewChild('searchWidget') searchWidget!: SearchWidgetComponent;
  @ViewChild('filterWidget') filterWidget!: FilterWidgetComponent;

  constructor(
    private service: BwUserService,
    private toastService: ToastService
  ) {}

  async findBwUsers() {
    this.loading = true;
    const filteredStatus = this.findOptions.filters?.[0]?.value;
    if (!filteredStatus?.length) {
      this.findOptions.filters![0].value = [{ label: 'Pendente', value: 'Pendente' }];
    }
    let response = await this.service.findBwUserCompanyGroups(this.findOptions).catch(err => {
      if (!err?.messageShown)
        this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });

    if (response?.data) {
      this.bwUsers = response.data;
    }

    if (response?.meta?.total != null && response?.meta?.total >= 0) {
      this.totalItems = response.meta.total;
    }
    this.loading = false;
  }

  async paginate(findOptions?: FindOptions) {
    if (findOptions) this.findOptions = { ...this.findOptions, ...findOptions };

    if (this.findOptions?.q) {
      this.searchWidget.updateValue(this.findOptions.q);
    }

    await this.findBwUsers();
  }

  onSearch(searchText?: string) {
    if (searchText != this.findOptions.q) {
      this.findOptions.q = searchText;
      this.goToFirstPage();
    }
  }

  goToFirstPage() {
    this.paginate({ page: 1 });
    this.paginator.component.first = 0;
  }

  changeStatus(bwUserCg: any, status: string) {
    let oldBwUserCg = JSON.parse(JSON.stringify(bwUserCg));
    bwUserCg.status = status;
    this.loadingBwUser = bwUserCg.bw_user_id;
    this.service
      .saveBwUserCompanyGroup(bwUserCg)
      .then((response: any) => {
        if (response.status)
          this.toastService.show({
            color: 'success',
            message: `Status alterado para: ${response.status}`,
          });

        if (
          !this.filterWidget.activeFilters
            .find(i => i.key == 'status')
            ?.value.includes(response.status)
        ) {
          this.bwUsers.splice(
            this.bwUsers.findIndex(i => i.bw_user_id == response.bw_user_id),
            1
          );
        }
      })
      .catch(err => {
        this.bwUsers[this.bwUsers.findIndex(i => i.bw_user_id == bwUserCg.bw_user_id)] =
          oldBwUserCg;
        if (!err?.messageShown)
          this.toastService.show({ color: 'error', message: 'Houve um erro ao salvar o usuário' });
      })
      .finally(() => {
        this.loadingBwUser = undefined;
      });
  }
}
